import { styled } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';

const StyledDataGrid = styled(DataGrid, {
    shouldForwardProp: (prop) => prop !== 'nbRows',
})(({ theme }) => ({
    border: 0,
    paddingTop: 4,
    fontFamily: ['Source Sans Pro'].join(','),
    fontSize: '16px',
    WebkitFontSmoothing: 'auto',
    letterSpacing: 'normal',
    '&.MuiDataGrid-root .MuiDataGrid-row': {
        borderRadius: '4px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: `inset 0px 0px 0px 1px ${theme.palette.info.dark}`,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
            boxShadow: `inset 0px 0px 0px 1px ${theme.palette.primary.accent}`,
        }
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeaders': {
        marginBottom: '10px',
        borderRadius: '4px',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.info.light,
        boxShadow: `inset 0px 0px 0px 1px ${theme.palette.info.dark}`,
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeader': {
        '&:focus': {
            outline: 0,
        },
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnSeparator': {
        visibility: 'hidden',
    },
    '&.MuiDataGrid-row, .MuiDataGrid-cell': {
        border: 0,
        '&:focus': {
            outline: 0,
        },
        '&:focus-within': {
            outline: 0,
        },
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer': {
        paddingLeft: 0,
    },
    '&.MuiDataGrid-row, .table-cell-truncate': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline'
    },
    '&.MuiDataGrid-root .MuiDataGrid-row .MuiDataGrid-cell > .MuiBox-root': {
        height: '100%',
        width: '100%',
        alignItems: 'center',
        display: 'flex',
    },
    '& .MuiDataGrid-virtualScroller': {
        scrollbarWidth: 'none'
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
        display: 'none'
    },
    '& .MuiDataGrid-footerContainer': {
        border: 0,
    },
}));

export { StyledDataGrid };
